"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INSERT_CALLOUT = exports.DRAG_DROP_ANCHOR = exports.EDIT_ANCHOR = exports.INSERT_ANCHOR = exports.PASTE_CONTENT = exports.EDIT_TABLE = exports.INSERT_TABLE = exports.OPEN_TABLE_POPOVER = exports.INSERT_EMOJI = exports.OPEN_EMOJI_POPOVER = exports.APPLY_COLOR_MODAL = exports.OPEN_COLOR_MODAL = exports.APPLY_COLOR_POPOVER = exports.CHANGE_COLOR_POPOVER_MODE = exports.RESET_COLOR_TO_DEFAULT = exports.OPEN_COLOR_POPOVER = exports.TOGGLE_VISUAL_BLOCKS = exports.EDIT_SOURCE_CODE = exports.OPEN_RSS_TOKEN = exports.INSERT_RSS_TOKEN = exports.OPEN_FORM_PICKER = exports.INSERT_HUBSPOT_VIDEO = exports.OPEN_VIDEO_PICKER = exports.EDIT_MEDIA_EMBED = exports.INSERT_MEDIA_EMBED = exports.OPEN_EMBED_MODAL = exports.UPDATE_CTA = exports.INSERT_CTA = exports.OPEN_CTA_PICKER = exports.INSERT_PERSONALIZATION_TOKEN = exports.OPEN_PROPERTY_BROWSER = exports.INSERT_LINK_TO_FILE = exports.OPEN_FILE_PICKER = exports.UPDATE_LINK = exports.INSERT_LINK = exports.MAKE_ORDERED_LIST = exports.MAKE_UNORDERED_LIST = exports.ESCAPE_BLOCK_FORMAT = exports.CHANGE_BLOCK_FORMAT = exports.CHANGE_LINE_HEIGHT = exports.CHANGE_FONT = exports.CHANGE_FONT_SIZE = exports.CHANGE_INLINE_STYLE = exports.AUTOMATIC_IMAGE_UPLOAD = exports.REPLACE_IMAGE = exports.REMOVE_IMAGE = exports.ALIGN_IMAGE = exports.INSERT_IMAGE = exports.OPEN_IMAGE_PICKER = void 0;
var OPEN_IMAGE_PICKER = 'open-image-picker';
exports.OPEN_IMAGE_PICKER = OPEN_IMAGE_PICKER;
var INSERT_IMAGE = 'insert-image';
exports.INSERT_IMAGE = INSERT_IMAGE;
var ALIGN_IMAGE = 'align-image';
exports.ALIGN_IMAGE = ALIGN_IMAGE;
var REMOVE_IMAGE = 'remove-image';
exports.REMOVE_IMAGE = REMOVE_IMAGE;
var REPLACE_IMAGE = 'replace-image';
exports.REPLACE_IMAGE = REPLACE_IMAGE;
var AUTOMATIC_IMAGE_UPLOAD = 'automatic-image-upload';
exports.AUTOMATIC_IMAGE_UPLOAD = AUTOMATIC_IMAGE_UPLOAD;
var CHANGE_INLINE_STYLE = 'change-inline-style';
exports.CHANGE_INLINE_STYLE = CHANGE_INLINE_STYLE;
var CHANGE_FONT_SIZE = 'change-font-size';
exports.CHANGE_FONT_SIZE = CHANGE_FONT_SIZE;
var CHANGE_FONT = 'change-font';
exports.CHANGE_FONT = CHANGE_FONT;
var CHANGE_LINE_HEIGHT = 'change-line-height';
exports.CHANGE_LINE_HEIGHT = CHANGE_LINE_HEIGHT;
var CHANGE_BLOCK_FORMAT = 'change-block-format';
exports.CHANGE_BLOCK_FORMAT = CHANGE_BLOCK_FORMAT;
var ESCAPE_BLOCK_FORMAT = 'escape-block-format';
exports.ESCAPE_BLOCK_FORMAT = ESCAPE_BLOCK_FORMAT;
var MAKE_UNORDERED_LIST = 'make-unordered-list';
exports.MAKE_UNORDERED_LIST = MAKE_UNORDERED_LIST;
var MAKE_ORDERED_LIST = 'make-ordered-list';
exports.MAKE_ORDERED_LIST = MAKE_ORDERED_LIST;
var INSERT_LINK = 'insert-link';
exports.INSERT_LINK = INSERT_LINK;
var UPDATE_LINK = 'update-link';
exports.UPDATE_LINK = UPDATE_LINK;
var OPEN_FILE_PICKER = 'open-file-picker';
exports.OPEN_FILE_PICKER = OPEN_FILE_PICKER;
var INSERT_LINK_TO_FILE = 'insert-link-to-file';
exports.INSERT_LINK_TO_FILE = INSERT_LINK_TO_FILE;
var OPEN_PROPERTY_BROWSER = 'open-contact-propery-browser';
exports.OPEN_PROPERTY_BROWSER = OPEN_PROPERTY_BROWSER;
var INSERT_PERSONALIZATION_TOKEN = 'insert-personalization-token';
exports.INSERT_PERSONALIZATION_TOKEN = INSERT_PERSONALIZATION_TOKEN;
var OPEN_CTA_PICKER = 'open-cta-picker';
exports.OPEN_CTA_PICKER = OPEN_CTA_PICKER;
var INSERT_CTA = 'insert-cta';
exports.INSERT_CTA = INSERT_CTA;
var UPDATE_CTA = 'update-cta';
exports.UPDATE_CTA = UPDATE_CTA;
var OPEN_EMBED_MODAL = 'open-embed-modal';
exports.OPEN_EMBED_MODAL = OPEN_EMBED_MODAL;
var INSERT_MEDIA_EMBED = 'insert-embed-code';
exports.INSERT_MEDIA_EMBED = INSERT_MEDIA_EMBED;
var EDIT_MEDIA_EMBED = 'edit-embed-code';
exports.EDIT_MEDIA_EMBED = EDIT_MEDIA_EMBED;
var OPEN_VIDEO_PICKER = 'open-video-picker';
exports.OPEN_VIDEO_PICKER = OPEN_VIDEO_PICKER;
var INSERT_HUBSPOT_VIDEO = 'insert-hubspot-video';
exports.INSERT_HUBSPOT_VIDEO = INSERT_HUBSPOT_VIDEO;
var OPEN_FORM_PICKER = 'open-form-picker';
exports.OPEN_FORM_PICKER = OPEN_FORM_PICKER;
var INSERT_RSS_TOKEN = 'insert-rss-token';
exports.INSERT_RSS_TOKEN = INSERT_RSS_TOKEN;
var OPEN_RSS_TOKEN = 'open-rss-token-popover';
exports.OPEN_RSS_TOKEN = OPEN_RSS_TOKEN;
var EDIT_SOURCE_CODE = 'edit-source-code';
exports.EDIT_SOURCE_CODE = EDIT_SOURCE_CODE;
var TOGGLE_VISUAL_BLOCKS = 'toggle-visual-blocks';
exports.TOGGLE_VISUAL_BLOCKS = TOGGLE_VISUAL_BLOCKS;
var OPEN_COLOR_POPOVER = 'open-colorpicker-popover';
exports.OPEN_COLOR_POPOVER = OPEN_COLOR_POPOVER;
var RESET_COLOR_TO_DEFAULT = 'reset-color-to-default';
exports.RESET_COLOR_TO_DEFAULT = RESET_COLOR_TO_DEFAULT;
var CHANGE_COLOR_POPOVER_MODE = 'change-colorpicker-mode';
exports.CHANGE_COLOR_POPOVER_MODE = CHANGE_COLOR_POPOVER_MODE;
var APPLY_COLOR_POPOVER = 'change-color';
exports.APPLY_COLOR_POPOVER = APPLY_COLOR_POPOVER;
var OPEN_COLOR_MODAL = 'open-colorpicker-modal';
exports.OPEN_COLOR_MODAL = OPEN_COLOR_MODAL;
var APPLY_COLOR_MODAL = 'change-color-modal';
exports.APPLY_COLOR_MODAL = APPLY_COLOR_MODAL;
var OPEN_EMOJI_POPOVER = 'open-emoji-picker-popover';
exports.OPEN_EMOJI_POPOVER = OPEN_EMOJI_POPOVER;
var INSERT_EMOJI = 'insert-emoji';
exports.INSERT_EMOJI = INSERT_EMOJI;
var OPEN_TABLE_POPOVER = 'open-table-popover';
exports.OPEN_TABLE_POPOVER = OPEN_TABLE_POPOVER;
var INSERT_TABLE = 'insert-table';
exports.INSERT_TABLE = INSERT_TABLE;
var EDIT_TABLE = 'edit-table';
exports.EDIT_TABLE = EDIT_TABLE;
var PASTE_CONTENT = 'paste';
exports.PASTE_CONTENT = PASTE_CONTENT;
var INSERT_ANCHOR = 'insert-anchor';
exports.INSERT_ANCHOR = INSERT_ANCHOR;
var EDIT_ANCHOR = 'edit-anchor';
exports.EDIT_ANCHOR = EDIT_ANCHOR;
var DRAG_DROP_ANCHOR = 'drag-drop-anchor';
exports.DRAG_DROP_ANCHOR = DRAG_DROP_ANCHOR;
var INSERT_CALLOUT = 'insert-callout';
exports.INSERT_CALLOUT = INSERT_CALLOUT;